import React from "react";
import styled from "styled-components";
import {InlineHeartComp} from "../howIsItWorking/HowIsItWorking";
import TextArea from "../textArea/TextArea";
import Colors from "../../constants/Colors";
import {deviceMax, deviceMin} from "../../../styles/device";
import ViewPositionsButton from "../heroAreaButtons/ViewPositionsButton";
import ScrollButton from "../buttons/scrollButton/ScrollButton";


const CareerHeroAreaContent = () => {

    return (
        <CareerHeroAreaContentWrapper>
            <TextArea>
                <h2>Pembe Panjur ile Kariyerinizi büyütün</h2>
                <ScrollButton>
                    Pozisyonları incele
                </ScrollButton>
                {/*<ViewPositionsButton backgroundColor={'#fff'} textColor={false} career={true} clickHandler={handleClickScroll}/>*/}
                <CareerHeroAreaContentDesktopWrapper>
                    <p>
                        Panjur Bilişim ve Danışmanlık Hizmetleri Ticaret A.Ş., yenilikçi, öncü ve istikrarlı kurum
                        kimliğiyle 2010 yılından beri bilişim sektöründe hizmet vermektedir. Alanının lider
                        firmalarından
                        biri olan Panjur Bilişim'in kurduğu Pembe Panjur evlilik sitesi, teknolojik altyapısı ve 10
                        milyonun
                        üzerinde üyesiyle Türkiye'nin en büyük evlilik sitesi unvanına sahiptir.
                    </p>
                    <p>
                        Profesyonel, etik değerlere saygılı, hizmette kaliteyi hedefleyen Panjur Bilişim, üyelerine
                        sunduğu
                        servislerle maksimum faydayı gözetmektedir.
                    </p>
                    <p>
                        Çalışan kültürüne büyük önem veren Panjur Bilişim kendini sürekli yenileyerek büyüme amacına
                        uygun
                        bir yaklaşım sergilemektedir. Panjur Bilişim çalışanları alanında tecrübeli, yaratıcı, özverili,
                        ekip ruhuna sahip ve dinamik bireylerden oluşmaktadır.
                    </p>
                    {/*<ul>*/}
                    {/*    <li>*/}
                    {/*        <InlineHeartComp/>*/}
                    {/*        Uc tane title koyalim karakteristik*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <InlineHeartComp/>*/}
                    {/*        Lorem ipum musunuz?*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <InlineHeartComp/>*/}
                    {/*        Sed dormet como esta misiniz?*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <InlineHeartComp/>*/}
                    {/*        Baska bir tane daha misiniz?*/}
                    {/*    </li>*/}
                    {/*</ul>*/}
                    <p>
                        Siz de bu özelliklere sahip olduğunuzu düşünüyorsanız açık pozisyonlarımızı inceleyin.
                    </p>
                </CareerHeroAreaContentDesktopWrapper>

            </TextArea>
        </CareerHeroAreaContentWrapper>
    )
}

const CareerHeroAreaContentDesktopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: unset;
  width: 100%;

  > h2 {
    font-weight: 800;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0;
    text-transform: uppercase;
    color: ${Colors.white};
    margin-top: 0;
    margin-bottom: 17px;

    @media ${deviceMax.laptop} {
      text-align: center;
      font-size: 18px;
      line-height: 28px;
    }
  }

  > h3 {
    font-weight: 700;
    font-size: 30px;
    line-height: 45px;
    letter-spacing: 0;
    color: ${Colors.white};
    margin-bottom: 45px;

    @media ${deviceMax.laptop} {
      text-align: center;
      font-size: 16px;
      line-height: 24px;
      margin-top: 6px;
      margin-bottom: 30px;
    }
  }

  > p {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    color: ${Colors.white};
    margin-top: 0;

    @media ${deviceMax.laptop} {
      text-align: center;
    }
  }

  > ul {
    list-style: none;
    padding: 0;
    margin: 0 0 28px 0;

    > li {
      margin-bottom: 10px;
      font-weight: 800;
      font-size: 20px;
      line-height: 22px;
      letter-spacing: 0;
      color: ${Colors.white};
      padding-left: 35px;

      > div {
        &:before, &:after {
          background: ${Colors.white};
        }
      }

      @media ${deviceMax.laptop} {
        font-size: 18px;
        padding-left: 55px;
      }
    }
  }
  
  @media ${deviceMax.laptop} {
    display: none;

  }
`;

const CareerHeroAreaContentWrapper = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 57px;
  padding-bottom: 25px;
  
  @media ${deviceMax.laptop} {
    flex: 2;
    margin-bottom: 0 !important;
    align-items: flex-end !important;
    padding-top: 20px;
  }

  @media ${deviceMax.tablet} {
    flex: 1;
    padding-top: 10px;
    padding-bottom: 3px;
  }

  > div {
    display: flex;
    flex-direction: column;
    background-color: unset;
    padding: 0 40px 20px 25px;
    width: 100%;

    @media ${deviceMax.laptop} {
      align-items: center;
      padding-bottom: 0;
      padding-right: 50px;
      padding-left: 50px;
    }

    @media ${deviceMax.tablet} {
      padding-right: 25px;
      padding-left: 25px;
    }

    > h2 {
      font-weight: 800;
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 0;
      text-transform: uppercase;
      color: ${Colors.white};
      margin-top: 0;
      margin-bottom: 17px;

      @media ${deviceMax.laptop} {
        text-align: center;
        font-size: 38px;
        line-height: 55px;
      }

      @media ${deviceMax.mobileM} {
        text-align: center;
        font-size: 30px;
        line-height: 40px;
      }
    }

    > h3 {
      font-weight: 700;
      font-size: 30px;
      line-height: 45px;
      letter-spacing: 0;
      color: ${Colors.white};
      margin-bottom: 45px;

      @media ${deviceMax.laptop} {
        text-align: center;
        font-size: 16px;
        line-height: 24px;
        margin-top: 6px;
        margin-bottom: 30px;
      }
    }
  }
`;

export default CareerHeroAreaContent;
